module.exports = __webpack_public_path__ + "static/media/ig.d9a900dd.svg";